<template>
  <component
    :is="pageLayoutComponent"
    title="Detailní zacílení"
    :next="nextRoute"
    :prev="prevRoute"
  >
    <ReachDialBox :store-namespace="storeNamespace" class="mb-8" />
    <ui-section
      title="Pro lepší zacílení rozdělte okruhy zájmů ideálně do tří skupin"
      subtitle="Váše reklama bude cílená na lidi, kteří splňují podmínky každé skupiny"
    >
      <template v-for="(group, index) in interestsGroups">
        <interests-group
          class="my-4"
          :disable-delete="interestsGroups.length === 1"
          :group="group"
          :group-index="index"
          :key="'group-' + group.id"
          @groupRemove="interestsGroupRemove"
          @itemsAppend="interestsAppend"
          @itemsRemove="interestsRemove"
        />
      </template>

      <v-row>
        <v-col :sm="12">
          <button @click="interestsGroupAppend" class="addBtn" type="button">
            <span
              class="addBtn__content navy--text text-caption font-weight-bold"
            >
              <v-icon left color="navy">
                mdi-plus-circle-outline
              </v-icon>
              Přidat skupinu
            </span>
          </button>
        </v-col>
      </v-row>
    </ui-section>
  </component>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

// import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import ReachDialBox from "@/components/ui/targeting/ReachDialBox.vue"
import InterestsGroup from "@/components/ui/targeting/InterestsGroup.vue"

export default {
  name: "TargetingInterests",
  components: {
    // PageLayout,
    ReachDialBox,
    InterestsGroup,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...sync("app", ["videoTutorial"]),
    pageLayoutComponent() {
      return () =>
        import(`@/components/page/${this.storeNamespace}/edit/PageLayout.vue`)
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@audience.targeting`, ["interestsGroups"]),
    })

    Object.assign(this.$options.methods, {
      ...call(`${storeNamespace}`, [
        "interestsAppend",
        "interestsRemove",
        "interestsGroupAppend",
        "interestsGroupRemove",
      ]),
    })
  },
  mounted() {
    this.videoTutorial = "https://player.vimeo.com/video/693576497?h=7ffc4b4339"
  },
}
</script>

<style scoped>
.addBtn {
  width: 100%;
  height: 100%;
  border: 1px dashed #d7d7e2;
  border-radius: 6px;
  transition: all 0.3s;
}

.addBtn__content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 32px;
}

.addBtn:hover {
  background: rgba(215, 215, 226, 0.25);
}
</style>
